const selectorContainers = {
  'CIO/Analyst': [
    // Banner & Dropdown
    { id: 0, hidden: false },
    // Value Proposition
    { id: 1, hidden: false },
    // Solutions
    { id: 2, hidden: false },
    // RESOURCES
    { id: 5, hidden: false },
    // INSIGHTS
    { id: 3, hidden: false },
    // PRACTICE MANAGEMENT
    { id: 4, hidden: true },
    // EDUCATION
    { id: 6, hidden: true },
    // Request Contact
    { id: 7, hidden: false },
  ],

  'Principal/Founder': [
    // Banner & Dropdown
    { id: 0, hidden: false },
    // Value Proposition
    { id: 1, hidden: false },
    // PRACTICE MANAGEMENT
    { id: 4, hidden: false },
    // RESOURCES
    { id: 5, hidden: false },
    // INSIGHTS
    { id: 3, hidden: false },
    // Solutions
    { id: 2, hidden: false },
    // EDUCATION
    { id: 6, hidden: true },
    // Request Contact
    { id: 7, hidden: false },
  ],

  'Wealth Advisor/Financial Planner': [
    // Banner & Dropdown
    { id: 0, hidden: false },
    // Value Proposition
    { id: 1, hidden: false },
    // INSIGHTS
    { id: 3, hidden: false },
    // PRACTICE MANAGEMENT
    { id: 4, hidden: false },
    // EDUCATION
    { id: 6, hidden: false },
    // Solutions
    { id: 2, hidden: false },
    // RESOURCES
    { id: 5, hidden: true },
    // Request Contact
    { id: 7, hidden: false },
  ],

  'Compliance/Marketing': [
    // Banner & Dropdown
    { id: 0, hidden: false },
    // Value Proposition
    { id: 1, hidden: false },
    // EDUCATION
    { id: 6, hidden: false },
    // INSIGHTS
    { id: 3, hidden: false },
    // PRACTICE MANAGEMENT
    { id: 4, hidden: false },
    // Solutions
    { id: 2, hidden: true },
    // RESOURCES
    { id: 5, hidden: true },
    // Request Contact
    { id: 7, hidden: false },
  ],
}

// Default: all containers in order, all visible
const defaultContainers = [
  // Banner & Dropdown
  { id: 0, hidden: false },
  // Value Proposition
  { id: 1, hidden: false },
  // Solutions
  { id: 2, hidden: false },
  // INSIGHTS
  { id: 3, hidden: false },
  // PRACTICE MANAGEMENT
  { id: 4, hidden: false },
  // RESOURCES
  { id: 5, hidden: false },
  // EDUCATION
  { id: 6, hidden: false },
  // Request Contact
  { id: 7, hidden: false },
]
export { selectorContainers, defaultContainers }
